(function () {
  "use strict";

  /* Age gate (same behaviour as the original site) */
  var gate = document.getElementById("ageGate");
  var verified = false;
  try { verified = localStorage.getItem("drown_age_verified") === "true"; } catch (e) {}
  if (gate) {
    if (verified) {
      gate.classList.add("hidden");
      document.body.classList.remove("no-scroll");
    } else {
      document.body.classList.add("no-scroll");
      var yes = document.getElementById("ageYes");
      var no = document.getElementById("ageNo");
      if (yes) {
        yes.focus();
        yes.addEventListener("click", function () {
          try { localStorage.setItem("drown_age_verified", "true"); } catch (e) {}
          gate.style.transition = "opacity 0.6s ease-out";
          gate.style.opacity = "0";
          setTimeout(function () {
            gate.classList.add("hidden");
            document.body.classList.remove("no-scroll");
          }, 600);
        });
      }
      if (no) {
        no.addEventListener("click", function () {
          alert("You must be 18 years or older to enter this site.");
          window.location.href = "https://www.google.com";
        });
      }
    }
  }

  /* Reveal on scroll */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("reveal"); });
  }

  /* Background video slow zoom on scroll */
  var videoBg = document.querySelector(".video-bg");
  if (videoBg) {
    window.addEventListener("scroll", function () {
      var scale = 1 + window.pageYOffset * 0.0002;
      videoBg.style.transform = "scale(" + scale + ")";
    }, { passive: true });
  }

  /* Quantity +/- buttons */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty-step]");
    if (!btn) return;
    var input = btn.parentElement.querySelector(".qty-input");
    if (!input) return;
    var step = parseInt(btn.getAttribute("data-qty-step"), 10) || 0;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;
    var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || min) + step));
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* Date of birth on the cart page: required, 18+, before checkout */
  var cartForm = document.querySelector(".cart-form");
  var dobInput = cartForm ? cartForm.querySelector("[data-dob]") : null;
  if (cartForm && dobInput) {
    var now = new Date();
    var cutoff = new Date(now.getFullYear() - 18, now.getMonth(), now.getDate());
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    dobInput.max = cutoff.getFullYear() + "-" + pad(cutoff.getMonth() + 1) + "-" + pad(cutoff.getDate());
    dobInput.min = "1900-01-01";
    var lastClicked = null;
    cartForm.addEventListener("click", function (e) {
      var b = e.target.closest("button[type=submit]");
      if (b) lastClicked = b;
    });
    cartForm.addEventListener("submit", function (e) {
      var submitter = e.submitter || lastClicked;
      if (!submitter || submitter.name !== "checkout") return;
      var err = cartForm.querySelector("[data-dob-error]");
      var msg = "";
      if (!dobInput.value) {
        msg = "Please enter your date of birth.";
      } else {
        var d = new Date(dobInput.value + "T00:00:00");
        if (isNaN(d.getTime()) || d.getFullYear() < 1900) msg = "Please enter a valid date of birth.";
        else if (d > cutoff) msg = "You must be 18 or over to buy alcohol.";
      }
      if (msg) {
        e.preventDefault();
        if (err) { err.textContent = msg; err.hidden = false; }
        dobInput.focus();
      }
    });
  }

  /* Keep the customer's place after a waitlist / notify form posts */
  if (window.location.search.indexOf("customer_posted=true") !== -1 || window.location.hash === "#waitlist") {
    var target = document.querySelector(".waitlist-thanks.visible");
    if (target) target.scrollIntoView({ block: "center" });
  }
})();
